"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.shouldPolyfill = shouldPolyfill;
function shouldPolyfill() {
    return typeof Intl === 'undefined' || !('DurationFormat' in Intl);
}
